import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const SuccessPayment = () => {
  const navigate = useNavigate();

  useEffect(() => {

  }, [navigate]);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 text-center">
      <i className="bi bi-check-circle text-success display-1"></i>
      <h1 className="mt-4 fw-bold">Payment Successful!</h1>
      <p className="text-muted mt-2">Thank you for your purchase.</p>
      <button className="btn btn-primary mt-4" onClick={() => navigate("/account")}>Go to Account</button>
    </div>
  );
};

export default SuccessPayment;
